const account_center = {
    home: {
        title: 'Страница не найдена',
        description: 'Эта страница недоступна.',
    },
    page: {
        title: 'Аккаунт',
        security_title: 'Безопасность',
        security_description: 'Измените здесь настройки аккаунта, чтобы обеспечить его безопасность.',
        /** UNTRANSLATED */
        profile_title: 'Personal info',
        /** UNTRANSLATED */
        profile_description: 'Change your personal information here.',
        /** UNTRANSLATED */
        sidebar_personal_info: 'Personal info',
        /** UNTRANSLATED */
        sidebar_security: 'Security',
        support: 'Поддержка',
    },
    verification: {
        title: 'Проверка безопасности',
        description: 'Подтвердите, что это вы, чтобы защитить безопасность аккаунта. Пожалуйста, выберите способ подтверждения личности.',
        error_send_failed: 'Не удалось отправить код подтверждения. Попробуйте позже.',
        error_invalid_code: 'Код подтверждения недействителен или истёк.',
        error_verify_failed: 'Не удалось подтвердить. Введите код ещё раз.',
        verification_required: 'Срок действия проверки истёк. Подтвердите личность ещё раз.',
        try_another_method: 'Попробовать другой способ подтверждения',
        no_available_methods_title: 'Нет доступных способов подтверждения',
        no_available_methods_description: 'У вас не настроены способы подтверждения. Сначала добавьте к аккаунту пароль, email или номер телефона.',
    },
    password_verification: {
        title: 'Подтвердите пароль',
        description: 'Чтобы защитить аккаунт, введите пароль для подтверждения своей личности.',
        error_failed: 'Неверный пароль. Проверьте введённые данные.',
    },
    verification_method: {
        password: {
            name: 'Пароль',
            description: 'Подтвердите свой пароль',
        },
        email: {
            name: 'Код подтверждения по электронной почте',
            description: 'Отправить код подтверждения на вашу почту',
        },
        phone: {
            name: 'Код подтверждения по телефону',
            description: 'Отправить код подтверждения на ваш номер телефона',
        },
    },
    email: {
        title: 'Привязать email',
        description: 'Привяжите свой email, чтобы входить или помочь с восстановлением аккаунта.',
        verification_title: 'Введите код подтверждения email',
        verification_description: 'Код подтверждения отправлен на ваш email {{email_address}}.',
        success: 'Основной email успешно привязан.',
        verification_required: 'Срок действия проверки истёк. Подтвердите личность ещё раз.',
    },
    phone: {
        title: 'Привязать номер телефона',
        description: 'Привяжите номер телефона для входа или восстановления аккаунта.',
        verification_title: 'Введите код подтверждения SMS',
        verification_description: 'Код подтверждения отправлен на ваш телефон {{phone_number}}.',
        success: 'Основной телефон успешно привязан.',
        verification_required: 'Срок действия проверки истёк. Подтвердите личность ещё раз.',
    },
    username: {
        title: 'Установить имя пользователя',
        description: 'Имя пользователя может содержать только буквы, цифры и символы подчеркивания.',
        success: 'Имя пользователя успешно обновлено.',
    },
    security: {
        add: 'Добавить',
        change: 'Изменить',
        remove: 'Удалить',
        not_set: 'Не задано',
        social_sign_in: 'Социальный вход',
        social_not_linked: 'Не привязано',
        email_phone: 'Электронная почта / Телефон',
        email: 'Электронная почта',
        phone: 'Телефон',
        password: 'Пароль',
        configured: 'Настроено',
        not_configured: 'Не настроено',
        two_step_verification: 'Двухэтапная проверка',
        authenticator_app: 'Приложение для аутентификации',
        passkeys: 'Passkeys',
        backup_codes: 'Резервные коды',
        email_verification_code: 'Код подтверждения по электронной почте',
        phone_verification_code: 'Код подтверждения по телефону',
        passkeys_count_one: '{{count}} passkey',
        passkeys_count_other: '{{count}} passkeys',
        backup_codes_count_one: '{{count}} код остался',
        backup_codes_count_other: '{{count}} кодов осталось',
        view: 'Просмотр',
        manage: 'Управление',
        turn_on_2_step_verification_description: 'Добавьте дополнительный уровень безопасности. При входе вам будет предложен второй шаг верификации.',
        turn_off_2_step_verification: 'Отключить двухэтапную верификацию',
        turn_off_2_step_verification_description: 'Отключение двухэтапной верификации удалит дополнительный уровень защиты вашей учётной записи при входе. Вы уверены, что хотите продолжить?',
        disable_2_step_verification: 'Отключить',
        no_verification_method_warning: 'Вы не добавили второй способ верификации. Добавьте хотя бы один, чтобы включить двухэтапную верификацию при входе.',
        account_removal: 'Удаление аккаунта',
        delete_your_account: 'Удалите свой аккаунт',
        delete_account: 'Удалить аккаунт',
        remove_username_confirmation_title: 'Удалить имя пользователя',
        remove_username_confirmation_description: 'После удаления вы больше не сможете входить с этим именем пользователя. Вы уверены, что хотите продолжить?',
        remove_email_confirmation_title: 'Удалить адрес электронной почты',
        remove_email_confirmation_description: 'После удаления вы больше не сможете входить с этим адресом электронной почты. Вы уверены, что хотите продолжить?',
        remove_phone_confirmation_title: 'Удалить номер телефона',
        remove_phone_confirmation_description: 'После удаления вы больше не сможете входить с этим номером телефона. Вы уверены, что хотите продолжить?',
        email_removed: 'Адрес электронной почты успешно удалён.',
        phone_removed: 'Номер телефона успешно удалён.',
        username_removed: 'Имя пользователя успешно удалено.',
    },
    social: {
        linked: '{{connector}} успешно привязан.',
        not_enabled: 'Этот способ входа через социальную сеть не включён. Обратитесь к администратору за помощью.',
        removed: '{{connector}} успешно удален.',
        remove_confirmation_title: 'Удалить социальный аккаунт',
        remove_confirmation_description: 'Если вы удалите {{connector}}, возможно, вы не сможете входить с его помощью, пока не добавите его снова.',
    },
    password: {
        title: 'Установить пароль',
        description: 'Создайте новый пароль, чтобы защитить свой аккаунт.',
        success: 'Пароль успешно обновлён.',
    },
    code_verification: {
        send: 'Отправить код подтверждения',
        resend: 'Не получили? <a>Отправить код подтверждения ещё раз</a>',
        resend_countdown: 'Не получили? Повторная отправка через {{seconds}} с.',
    },
    email_verification: {
        title: 'Подтвердите свою почту',
        prepare_description: 'Подтвердите, что это вы, чтобы защитить свой аккаунт. Отправьте код подтверждения на свою почту.',
        email_label: 'Адрес электронной почты',
        send: 'Отправить код подтверждения',
        description: 'Код подтверждения отправлен на {{email}}. Введите код, чтобы продолжить.',
        resend: 'Не получили? <a>Отправить код подтверждения ещё раз</a>',
        not_received: 'Не получили?',
        resend_action: 'Отправить код подтверждения ещё раз',
        resend_countdown: 'Не получили? Повторная отправка через {{seconds}} с.',
        error_send_failed: 'Не удалось отправить код подтверждения. Попробуйте позже.',
        error_verify_failed: 'Не удалось подтвердить. Введите код ещё раз.',
        error_invalid_code: 'Код подтверждения недействителен или истёк.',
    },
    phone_verification: {
        title: 'Подтвердите свой телефон',
        prepare_description: 'Подтвердите, что это вы, чтобы защитить безопасность аккаунта. Отправьте код подтверждения на свой телефон.',
        phone_label: 'Номер телефона',
        send: 'Отправить код подтверждения',
        description: 'Код подтверждения отправлен на ваш телефон {{phone}}. Введите код, чтобы продолжить.',
        resend: 'Не получили? <a>Отправить код подтверждения ещё раз</a>',
        resend_countdown: 'Не получили? Повторная отправка через {{seconds}} с.',
        error_send_failed: 'Не удалось отправить код подтверждения. Попробуйте позже.',
        error_verify_failed: 'Не удалось подтвердить. Введите код ещё раз.',
        error_invalid_code: 'Код подтверждения недействителен или истёк.',
    },
    mfa: {
        totp_already_added: 'Вы уже добавили приложение для аутентификации. Пожалуйста, сначала удалите существующее.',
        totp_not_enabled: 'Приложение для аутентификации OTP не включено. Обратитесь к администратору за помощью.',
        backup_code_already_added: 'У вас уже есть активные резервные коды. Пожалуйста, используйте или удалите их перед созданием новых.',
        backup_code_not_enabled: 'Резервный код не включен. Обратитесь к администратору за помощью.',
        backup_code_requires_other_mfa: 'Резервные коды требуют предварительной настройки другого метода MFA.',
        passkey_not_enabled: 'Passkey не включен. Обратитесь к администратору за помощью.',
        passkey_already_registered: 'Этот passkey уже зарегистрирован в вашем аккаунте. Пожалуйста, используйте другой аутентификатор.',
    },
    update_success: {
        default: {
            title: 'Обновлено!',
            description: 'Ваша информация была обновлена.',
        },
        email: {
            title: 'Электронная почта обновлена!',
            description: 'Ваш адрес электронной почты был успешно обновлен.',
        },
        phone: {
            title: 'Номер телефона обновлен!',
            description: 'Ваш номер телефона был успешно обновлен.',
        },
        username: {
            title: 'Имя пользователя изменено!',
            description: 'Ваше имя пользователя было успешно обновлено.',
        },
        password: {
            title: 'Пароль изменен!',
            description: 'Ваш пароль был успешно обновлен.',
        },
        totp: {
            title: 'Приложение для аутентификации добавлено!',
            description: 'Ваше приложение для аутентификации было успешно привязано к вашему аккаунту.',
        },
        totp_replaced: {
            title: 'Приложение для аутентификации заменено!',
            description: 'Ваше приложение для аутентификации было успешно заменено.',
        },
        backup_code: {
            title: 'Резервные коды созданы!',
            description: 'Ваши резервные коды сохранены. Храните их в надежном месте.',
        },
        passkey: {
            title: 'Passkey добавлен!',
            description: 'Ваш passkey был успешно привязан к вашему аккаунту.',
        },
        social: {
            title: 'Социальный аккаунт привязан!',
            description: 'Ваш социальный аккаунт был успешно привязан.',
        },
    },
    backup_code: {
        title: 'Резервные коды',
        description: 'Вы можете использовать один из этих резервных кодов для доступа к своей учетной записи, если у вас возникнут проблемы при двухэтапной проверке другими способами. Каждый код можно использовать только один раз.',
        copy_hint: 'Обязательно скопируйте их и сохраните в надежном месте.',
        generate_new_title: 'Сгенерировать новые резервные коды',
        generate_new: 'Сгенерировать новые резервные коды',
    },
    passkey: {
        title: 'Passkeys',
        added: 'Добавлен: {{date}}',
        last_used: 'Последнее использование: {{date}}',
        never_used: 'Никогда',
        unnamed: 'Безымянный passkey',
        renamed: 'Passkey успешно переименован.',
        deleted: 'Passkey успешно удалён.',
        add_another_title: 'Добавить другой passkey',
        add_another_description: 'Зарегистрируйте свой passkey с помощью биометрии устройства, ключей безопасности (например, YubiKey) или других доступных методов.',
        add_passkey: 'Добавить passkey',
        delete_confirmation_title: 'Удалить ваш passkey',
        delete_confirmation_description: 'Если вы удалите этот passkey, вы не сможете использовать его для проверки.',
        rename_passkey: 'Переименовать passkey',
        rename_description: 'Введите новое имя для этого passkey.',
        name_this_passkey: 'Назвать этот passkey устройства',
        name_passkey_description: 'Вы успешно подтвердили это устройство для двухэтапной аутентификации. Настройте имя, чтобы различать ключи, если их несколько.',
        name_input_label: 'Имя',
    },
};
export default Object.freeze(account_center);
